/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
 */
export interface FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest {
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    AuthenticationType: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    Game: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    Locale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    SessionId?: string | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    SteamLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    SteamOpenIdLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    EgsLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    GoogleLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    FacebookLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLogin | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    AuthenticateWithExternalIdGameAccessToken?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    AwAuthData?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthData | null;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin}
     * @memberof FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest
     */
    VkIdLogin?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin | null;
}



/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest(value: object): value is FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest {
    if (!('AuthenticationType' in value) || value['AuthenticationType'] === undefined) return false;
    if (!('Game' in value) || value['Game'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'AuthenticationType': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON(json['AuthenticationType']),
        'Game': json['Game'],
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
        'SessionId': json['SessionId'] == null ? undefined : json['SessionId'],
        'SteamLogin': json['SteamLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginFromJSON(json['SteamLogin']),
        'SteamOpenIdLogin': json['SteamOpenIdLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginFromJSON(json['SteamOpenIdLogin']),
        'EgsLogin': json['EgsLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginFromJSON(json['EgsLogin']),
        'GoogleLogin': json['GoogleLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSON(json['GoogleLogin']),
        'FacebookLogin': json['FacebookLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginFromJSON(json['FacebookLogin']),
        'AuthenticateWithExternalIdGameAccessToken': json['AuthenticateWithExternalIdGameAccessToken'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON(json['AuthenticateWithExternalIdGameAccessToken']),
        'AwAuthData': json['AwAuthData'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataFromJSON(json['AwAuthData']),
        'VkIdLogin': json['VkIdLogin'] == null ? undefined : FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSON(json['VkIdLogin']),
    };
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestToJSON(json: any): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AuthenticationType': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON(value['AuthenticationType']),
        'Game': value['Game'],
        'Locale': value['Locale'],
        'SessionId': value['SessionId'],
        'SteamLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamLoginToJSON(value['SteamLogin']),
        'SteamOpenIdLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestSteamOpenIdLoginToJSON(value['SteamOpenIdLogin']),
        'EgsLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestEgsLoginToJSON(value['EgsLogin']),
        'GoogleLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSON(value['GoogleLogin']),
        'FacebookLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFacebookLoginToJSON(value['FacebookLogin']),
        'AuthenticateWithExternalIdGameAccessToken': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON(value['AuthenticateWithExternalIdGameAccessToken']),
        'AwAuthData': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAwAuthDataToJSON(value['AwAuthData']),
        'VkIdLogin': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSON(value['VkIdLogin']),
    };
}

